import { SEMESTER } from "@cs124/person"
import { CALENDAR_IDS } from "~/constants"
export const CourseCalendar: React.FC<{ semester?: string }> = props => {
  const semester = props.semester ?? SEMESTER
  const calendar = CALENDAR_IDS[semester]
  if (!calendar) {
    throw `No calendar for ${semester}`
  }
  return (
    <iframe
      style={{ width: "100%", height: "400px" }}
      src={`https://calendar.google.com/calendar/embed?height=400&wkst=2&ctz=America%2FChicago&showPrint=0&showTitle=0&mode=AGENDA&showCalendars=0&src=${calendar}&color=%23ef6c00`}
    ></iframe>
  )
}
